import { useMutation } from "@apollo/client/react";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Grid } from "@mui/material";
import CardBox from "../../CardBox/CardBox";
import { RenderInputByTypeMobile } from "../../../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import { useVisita } from "../../../../../../context/VisitaContext";
import SAVE_VALORACION_AE_DI, { adaptAddVisitaPresencialAEValoracionInput } from "../../../../../../data/graphQL/mutations/Visitas/saveValoracion";
import { useStepSave } from "../../../../hooks/useStepSave";

import { ID_TIPO_VISITA_PRESENCIAL } from "../../../MisVisitasCreationContent";
import toast from "react-hot-toast";
import { VALORACION_ACCESO_INTEGRO_ID, VALORACION_ACCESO_PERMEABLE_ID } from "../../../../constants/valoracionAccesoIds";
import { validateStepFields } from "../../../../utils/visitaStepValidation";
import { comboVisitaValorIds } from "../../../../constants/comboVisitaValorIds";

export default function Valoracion({ esUrgencia, readOnly, onSaveRef, onExposeFormatted, programa }) {
  const [formData, setFormData] = useState({});

  const { visita, setVisita } = useVisita();

  const [save] = useMutation(SAVE_VALORACION_AE_DI);

  const handleChange = useCallback((name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  }, []);

  const formattedInputs = useMemo(() => {
    return inputs.map((input) => {
      const newInput = { ...input };

      const visitaProgramada = visita?.idComboVisitaValorFormaVisita === comboVisitaValorIds.VISITA_PROGRAMADA_ID;
      if (!visitaProgramada) {
        newInput.required = false;
      }

      if (esUrgencia) newInput.required = false;

      if (readOnly) newInput.disabled = true;

      return newInput;
    });
  }, [readOnly, esUrgencia, visita?.idComboVisitaValorFormaVisita]);

  useStepSave(onSaveRef, async (validate) => {
    if (validate) validateStepFields({ formattedInputs, formData });

    const { data } = await save({ variables: { input: adaptAddVisitaPresencialAEValoracionInput(formData) } });

    const idPresencialAENueva = data?.saveVisitaPresencialAEValoracion?.idPresencialAE;
    if (!idPresencialAENueva) throw new Error("Error al guardar");

    setVisita((prev) => ({
      ...prev,
      ...formData,
      integro: formData.accesoIntegro,
      permeable: formData.accesoPermeable,
      idPresencialAE: idPresencialAENueva
    }));

  });

  useEffect(() => {
    setFormData((prev) => ({ ...prev, ...visita }));
  }, [visita]);

  useEffect(() => {
    onExposeFormatted?.({
      stepId: 'valoracion',
      stepName: 'Valoración',
      formattedInputs
    });
  }, [onExposeFormatted, formattedInputs]);

  return (
    <CardBox>
      <Grid container spacing={2}>
        {formattedInputs.map((input) =>
          <Grid size={{ xs: input.halfSpace ? 4 : 12 }} key={input.name}>
            {input.type !== 'label' && <RenderInputByTypeMobile
              key={`${input.name}-${input.type}${input.type === 'multiple_boolean' ? formData[input.name] : ''}`}
              input={input}
              handleChange={handleChange}
              row={input.type === 'multiple_boolean'}
              value={formData[input.name]} />
            }
            {(input.type === 'label') &&
              <label style={{ textDecoration: 'underline', fontSize: '1rem' }}>{input.displayName}</label>
            }
          </Grid>
        )}
      </Grid>
    </CardBox>);

}

const diuresisOpcs = [
  { value: true, label: "Positiva" },
  { value: false, label: "Negativa" }];


const inputs = [
  {
    name: 'distencion',
    displayName: 'Distención',
    type: "boolean",
    lightTitle: true,
    required: true
  },
  {
    name: 'constipacion',
    displayName: 'Constipación',
    type: "boolean",
    lightTitle: true,
    required: true
  },
  {
    name: 'diarrea',
    displayName: 'Diarrea',
    type: "boolean",
    lightTitle: true,
    required: true
  },
  {
    name: "diuresis",
    displayName: "Diuresis",
    type: "multiple_boolean",
    options: diuresisOpcs,
    required: true,
    row: true,
    lightTitle: true
  },
  {
    name: "cantidadDiuresis",
    displayName: "Cantidad Diuresis (ml)",
    type: "int"
  },
  {
    name: "toleranciaTratamiento",
    displayName: "Tolerancia al tratamiento",
    type: "boolean",
    lightTitle: true,
    required: true
  },
  {
    name: "obsTolerancia",
    displayName: "OBS Tolerancia",
    type: "long_string",
    maxLength: 250
  },
  {
    name: "acceso",
    displayName: "Acceso",
    type: "label",
  },
  {
    name: "accesoIntegro",
    displayName: "Integro",
    type: "boolean",
    lightTitle: true,
    halfSpace: true,
    required: true
  },
  {
    name: "accesoPermeable",
    displayName: "Permeable",
    type: "boolean",
    lightTitle: true,
    halfSpace: true,
    required: true
  },
  {
    name: "cumplimientoIndicacion",
    displayName: "Cumplimiento de indicación",
    type: "boolean",
    lightTitle: true,
    required: true
  },
  {
    name: "obsCumplimientoIndicacion",
    displayName: "OBS Cumplimiento Indicación",
    type: "long_string",
    maxLength: 4000
  }];